(()=>{
'use strict';
if(window.__elcExpressV2CartLoaded)return;
window.__elcExpressV2CartLoaded=true;
const core=window.ExpressDeliveryCore;
const delivery=window.ELCExpressV2CartAPI;
if(!core||!delivery)return;
const root=()=>window.Shopify?.routes?.root||'/';
const panels=()=>[...document.querySelectorAll('[data-express-v2-cart-summary]')];
const itemBadges=()=>[...document.querySelectorAll('[data-express-v2-cart-item-badge]')];
function setItemBadge(node,state,label){
  node.dataset.deliveryState=state;
  node.textContent=label;
  node.hidden=!label;
  if(label)node.setAttribute('aria-label',label);
  else node.removeAttribute('aria-label');
}
function clearItemBadges(){
  itemBadges().forEach(node=>setItemBadge(node,'pending',''));
}
function setUnverifiedItemBadges(cart){
  const lines=new Map((cart?.items||[]).map(line=>[String(line.key||''),line]));
  itemBadges().forEach(node=>{
    const item=lines.get(node.dataset.lineKey);
    setItemBadge(node,item&&item.available!==false&&item.requires_shipping!==false?'check':'pending',item&&item.available!==false&&item.requires_shipping!==false?'Check delivery at checkout':'');
  });
}
function updateItemBadges(cart,requirements,stock,nearby){
  const lines=new Map((cart.items||[]).map(line=>[String(line.key||''),line]));
  const quantities=new Map(requirements.map(req=>[core.normalizeVariantGid(req.variantId),req.quantity]));
  itemBadges().forEach(node=>{
    const line=lines.get(node.dataset.lineKey);
    if(!line||line.available===false||line.requires_shipping===false){
      setItemBadge(node,'pending','');
      return;
    }
    const variantId=core.normalizeVariantGid(line.variant_id||line.id);
    const quantity=quantities.get(variantId);
    if(!quantity){setItemBadge(node,'pending','');return;}
    if(nearby.length&&core.findStoreForVariant(variantId,quantity,stock,nearby)){
      setItemBadge(node,'express','⚡ Express eligible');
      return;
    }
    const eta=delivery.standardFor(variantId,quantity,stock,null);
    if(eta?.deliveryDate){
      setItemBadge(node,'standard','🚚 Standard delivery');
    }else{
      setItemBadge(node,'check','Check delivery at checkout');
    }
  });
}
let sequence=0;
let queued=null;
function isVisible(){return panels().some(el=>el.dataset.context==='page'||!!el.closest('.cart-drawer.is-open'));}
function setPanel(state,title,description,location){
  panels().forEach(el=>{
    el.dataset.state=state;
    const heading=el.querySelector('[data-express-v2-cart-title]');
    const copy=el.querySelector('[data-express-v2-cart-description]');
    const icon=el.querySelector('[data-express-v2-cart-icon]');
    const area=el.querySelector('[data-express-v2-cart-area]');
    const action=el.querySelector('[data-express-v2-cart-location-action]');
    if(heading)heading.textContent=title;
    if(copy)copy.textContent=description;
    if(icon)icon.textContent=state==='express'?'⚡':'🚚';
    if(area){
      area.hidden=!location;
      area.textContent=location?'Deliver to: '+String(location.area||location.label||'Selected area'):'';
    }
    if(action){
      action.hidden=state==='none';
      action.textContent=location?'Change delivery location':'Choose delivery location';
    }
  });
}
function cartRequirements(cart){
  const shipping=(cart.items||[]).filter(item=>Number(item.quantity)>0&&item.requires_shipping!==false);
  const invalid=shipping.some(item=>item.available===false||!core.normalizeVariantGid(item.variant_id||item.id));
  const requirements=core.consolidateRequirements(shipping.map(item=>({variantId:item.variant_id||item.id,quantity:item.quantity})));
  return {requirements,invalid};
}
function standardArrival(requirements,stock){
  const estimates=requirements.map(req=>delivery.standardFor(req.variantId,req.quantity,stock,null));
  if(!estimates.length||estimates.some(eta=>!eta||!eta.deliveryDate))return '';
  return estimates.reduce((latest,eta)=>eta.deliveryDate>latest?eta.deliveryDate:latest,'');
}
async function getCart(){
  const response=await fetch(root()+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'});
  if(!response.ok)throw new Error('cart_unavailable');
  return response.json();
}
async function refresh(providedCart){
  if(!panels().length||!isVisible())return;
  const seq=++sequence;
  const location=delivery.readLocation();
  setPanel('loading','Checking delivery options…','Checking availability for all cart items.',location);
  clearItemBadges();
  let inspectedCart=null;
  try{
    const cart=providedCart&&Array.isArray(providedCart.items)?providedCart:await getCart();
    inspectedCart=cart;
    if(seq!==sequence)return;
    const {requirements,invalid}=cartRequirements(cart);
    if(!requirements.length){
      setPanel('none','No delivery required','There are no physical items requiring delivery in this cart.',null);
      return;
    }
    const config=delivery.readConfig();
    if(!String(config?.storefrontToken||'').trim())throw new Error('storefront_unconfigured');
    const position=location||{lat:25.0334958,lng:55.1862574};
    const stock=await delivery.queryInventory(requirements.map(item=>item.variantId),position);
    if(seq!==sequence)return;
    const nearby=location?delivery.eligibleStores(location):[];
    updateItemBadges(cart,requirements,stock,nearby);
    if(invalid){
      setPanel('unknown','Check delivery at checkout','One or more items are currently unavailable. Please review your cart.',location);
      return;
    }
    const common=nearby.length?core.findCommonStore(requirements,stock,nearby):null;
    if(common){
      const eta=delivery.getExpressPromise();
      const title=eta?.key==='today'?'⚡ Get it today':eta?.key==='tomorrow'?'⚡ Get it tomorrow':'⚡ Express Delivery available';
      const arrival=eta?.deliveryDate?' Estimated arrival: '+delivery.formatDate(eta.deliveryDate)+'.':'';
      setPanel('express',title,'All cart items qualify for Express from one nearby ELC store.'+arrival,location);
      return;
    }
    const date=standardArrival(requirements,stock);
    const heading=date?'🚚 Estimated Standard Delivery':'🚚 Standard Delivery';
    const dateNote=date?'Estimated arrival: '+delivery.formatDate(date)+'. ':'';
    const reason=!location?'Choose your delivery area to check Express for the entire cart.':!nearby.length?'Express is unavailable for the selected delivery area.':'Not all items qualify together from one nearby Express store.';
    setPanel('standard',heading,dateNote+reason+(date?'':' Confirm your delivery date at checkout.'),location);
  }catch(error){
    if(seq!==sequence)return;
    setUnverifiedItemBadges(inspectedCart);
    setPanel('unknown','Check delivery at checkout','The live stock estimate is temporarily unavailable. Please confirm shipping options at checkout.',location);
  }
}
function queueRefresh(cart){
  if(queued!==null)window.clearTimeout(queued);
  queued=window.setTimeout(()=>{queued=null;refresh(cart);},40);
}
function init(){
  if(panels().some(el=>el.dataset.context==='page'))queueRefresh(null);
}
document.addEventListener('click',event=>{
  const button=event.target.closest('[data-express-v2-cart-location-action]');
  if(!button)return;
  event.preventDefault();
  const drawer=button.closest('.cart-drawer.is-open');
  if(drawer)drawer.querySelector('[data-cart-close]')?.click();
  document.dispatchEvent(new CustomEvent('elc:express-delivery:action'));
});
document.addEventListener('elc:cart-drawer:opened',()=>queueRefresh(null));
document.addEventListener('elc:cart:updated',event=>queueRefresh(event.detail?.cart));
window.addEventListener('express-delivery:location-updated',()=>queueRefresh(null));
window.addEventListener('express-delivery:promise-refreshed',()=>queueRefresh(null));
document.addEventListener('shopify:section:load',()=>queueRefresh(null));
document.addEventListener('visibilitychange',()=>{if(!document.hidden)queueRefresh(null);});
window.addEventListener('pageshow',event=>{if(event.persisted)queueRefresh(null);});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
